export enum Paths {
  INICIO = 'inicio',
  NOSOTROS = 'nosotros',
  ANUNCIOS = 'anuncios',
  TUTORIALES = 'tutoriales',
  REGISTRO = 'registro',
}
